module.exports = __webpack_public_path__ + "media/7.bdc370a2.mp3";